// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingSpinnerWithOverlay-module__spinner___2MPAE"};